import React from 'react';
import Icon from '../../../components/AppIcon';


const RoleCard = ({ role, title, description, benefits, iconName }) => {
  return (
    <div 
      className="bg-white border-2 border-slate-200 rounded-lg p-6 space-y-4"
      style={{
        boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
      }}
    >
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name={iconName} size={24} className="text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">{title}</h3>
          <p className="text-sm text-muted-foreground capitalize">{role}</p>
        </div>
      </div>
      <p className="text-sm text-muted-foreground">{description}</p>
      {benefits && benefits?.length > 0 && (
        <div className="space-y-2">
          <p className="text-sm font-medium text-foreground">Wat u kunt verwachten:</p>
          <ul className="space-y-1">
            {benefits?.map((benefit, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
                <span>{benefit}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default RoleCard;